import { render, staticRenderFns } from "./SaveAndClose.vue?vue&type=template&id=e2adddac&"
import script from "./SaveAndClose.vue?vue&type=script&lang=js&"
export * from "./SaveAndClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports